import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)



const routes = [
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../components/Login.vue')
  },
  {
    path: '/Register',
    name: 'Register',
    component: () => import('../components/Register.vue')
  },
  {
    path: '/Forget',
    name: 'Forget',
    component: () => import('../components/Forget.vue')
  },
  {
    path: '/Map',
    name: 'Map',
    component: () => import('../components/Map.vue')
  },
  {
    path: '/CommunitySearchResult',
    name: 'CommunitySearchResult',
    component: () => import('../components/CommunitySearchResult.vue')
  },
  {
    path: '/PropertySearchResult',
    name: 'PropertySearchResult',
    component: () => import('../components/PropertySearchResult.vue')
  },
  {
    path: '/RentSearchResult',
    name: 'RentSearchResult',
    component: () => import('../components/RentSearchResult.vue')
  },
  {
    path: '/NewPropertySearchResult',
    name: 'NewPropertySearchResult',
    component: () => import('../components/NewPropertySearchResult.vue')
  },
  {
    path: '/SellHouse',
    name: 'SellHouse',
    component: () => import('../components/SellHouse.vue')
  },
  {
    path: '/SelectCity',
    name: 'SelectCity',
    component: () => import('../components/SelectCity.vue')
  },
  {
    path: '/UserResource',
    name: 'UserResource',
    component: () => import('../components/UserResource.vue')
  },
  {
    path: '/UserProfile',
    name: 'UserProfile',
    component: () => import('../components/UserProfile.vue')
  },
  {
    path: '/',
    name: 'HomePage',
    meta: { reload: true },
    component: () => import('../components/HomePage.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})


export default router